<div class="modal" [class.modal-show]="modalShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h3 class="title">Приклад підключення через АПІ на PHP для програмного скачування асортименту</h3>
  <div class="api-instruction-connect">
    <p>//Ідентифікатори валют: 1 = UAH, 2 = USD, 3 = EUR.</p>
    <p>$currency_id = 3;</p>
    <br>
    <p>//Готуємо логін та пароль</p>
    <p>$post = new stdClass();</p>
    <p>$post->login = "USER_EMAIL";</p>
    <p>$post->password = md5("USER_PASSWORD");</p>
    <p>$data = json_encode($post, JSON_UNESCAPED_UNICODE);</p>
    <br>
    <p>//Надсилання даних, і отримуємо відповідь</p>
    <p>$ch = curl_init();</p>
    <p>curl_setopt($ch, CURLOPT_URL, "https://maslotochka.com/api/get_goods_packages/$currency_id/");</p>
    <p>curl_setopt($ch, CURLOPT_RETURNTRANSFER, 1);</p>
    <p>curl_setopt($ch, CURLOPT_FOLLOWLOCATION, true);</p>
    <p>curl_setopt($ch, CURLOPT_HEADER, false);</p>
    <p>curl_setopt($ch, CURLOPT_POST, 1);</p>
    <p>curl_setopt($ch, CURLOPT_POSTFIELDS, $data);</p>
    <br>
    <p>$response = curl_exec($ch); curl_close($ch); unset($ch);</p>
    <p>$result = json_decode($response);</p>
    <br>
    <p>//Результат у $result</p>
    <p>if(isset($result->error)) {{'{'}}</p>
    <p>echo $result->error; exit;</p>
    <p>{{'}'}}</p>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
